import messages from '../../../../../assets/messages'
import {Trans} from 'react-i18next'
import {Button} from '@material-ui/core'

import {ModalContainer} from '../ModalContainer'
import {useStyles} from './styles'
import {WithdrawalMethodValues} from '../constants'

type ConfirmChangeWithdrawalMethodModalProps = {
  withdrawalMethod: WithdrawalMethodValues | null,
  onClose: () => void,
  onConfirm: (withdrawalMethodValue: WithdrawalMethodValues) => void,
}

function ConfirmChangeWithdrawalMethodModal(props: ConfirmChangeWithdrawalMethodModalProps) {
  const classes = useStyles()
  const {withdrawalMethod, onClose, onConfirm} = props

  const handleConfirm = () => {
    if (!withdrawalMethod) return

    onConfirm(withdrawalMethod)
  }

  return (
    <ModalContainer isOpen={Boolean(withdrawalMethod)} onClose={onClose}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.title}>
            <Trans {...messages.doYouWantToChangeYourPaymentMethod} />
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.text}>
            <Trans {...messages.onlyOnePaymentMethodCanBeUsed} />
          </div>
          <Button fullWidth color='primary' variant='contained' onClick={handleConfirm}>
            <Trans {...messages.switchPaymentMethod} />
          </Button>
          <Button fullWidth color='primary' variant='outlined' onClick={onClose}>
            <Trans {...messages.cancel} />
          </Button>
        </div>
      </div>
    </ModalContainer>
  )
}

export {ConfirmChangeWithdrawalMethodModal}
